import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { validateUserAddPermission } from "@/lib/api/auth"
import { Button } from "@/components/ui/button"
import {
  Credenza,
  CredenzaBody,
  CredenzaClose,
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from '@/components/ui/credenza'
import ZoneConnectionRatesForm from '@/components/forms/zone-connection-rates-form'
import { Header } from '@/components/header'
import { Icons } from '@/components/icons'

export const Route = createFileRoute(
  '/_home/zone-settings/zone-connection-rates/add',
)({
  component: AddZoneConnectionRatesPage,
})

export default function AddZoneConnectionRatesPage() {
  const [showZoneConnectionRatesModal, setShowZoneConnectionRatesModal] =
    React.useState<boolean>(false)

  return (
    <main>
      <Button
        onClick={() => {
          if (!validateUserAddPermission()) return
          setShowZoneConnectionRatesModal(!showZoneConnectionRatesModal)
        }}
      >
        <Icons.add />
        Add Zone Connection Rates
      </Button>
      <Credenza
        open={showZoneConnectionRatesModal}
        onOpenChange={setShowZoneConnectionRatesModal}
      >
        <CredenzaContent className="flex w-full max-w-[900px] justify-center">
          <CredenzaBody>
            <Header
              subroutes={[
                {
                  route: '/zone-settings/zone-connection-rates',
                  label: 'Zone Connection Rates',
                },
              ]}
            >
              Add Zone Connection Rate
            </Header>

            <ZoneConnectionRatesForm
              setShowZoneConnectionRatesModal={setShowZoneConnectionRatesModal}
            />
          </CredenzaBody>
        </CredenzaContent>
      </Credenza>
    </main>
  )
}
